import { memo, useCallback } from 'react';

import { HomefieldIconArrowBackspace } from '@dsg-tech/homefield-react-icons';
import { KEY_CODES } from 'utility/constants';
import { handleADA } from '@dsg-tech/homefield-utils';
import reactStringReplace from 'react-string-replace';
import { SearchState } from '../../types/index';

type Props = {
  suggestionResults: SearchState['suggestionResults'] | null;
  submitSearch: (term: string, type: string, url?: string) => string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  searchFromSuggestion: (term: string, type: string) => void;
  updateSearchTermSAYT: (term: string) => void;
  clickSuggestedTerm: (type: string) => void;
  productsContainerRef: React.RefObject<HTMLDivElement>;
};

const SuggestionKeywordsResults: React.FC<Props> = ({
  suggestionResults,
  submitSearch,
  searchTerm,
  setSearchTerm,
  searchFromSuggestion,
  updateSearchTermSAYT,
  clickSuggestedTerm,
  productsContainerRef,
}) => {
  const handleSuggestionClick = useCallback(
    (
      e: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.TouchEvent<HTMLButtonElement>,
      keyword: string,
    ) => {
      e.preventDefault();
      setSearchTerm(keyword);
      clickSuggestedTerm('keyword');
      window.location.href = submitSearch(keyword, 'keyword');
    },
    [setSearchTerm, clickSuggestedTerm, submitSearch],
  );

  return (
    <>
      {suggestionResults?.keywords?.map((keyword: string) => (
        <div
          key={`keyword-results-${keyword}`}
          data-testid="sayt-suggested-keywords"
          className="dsg-search-suggestion-result-container">
          <button
            // we cant use hmf <Button /> component here because "text" prop is required and will repeat the text twice
            type="button"
            className="dsg-search-suggestion-result hmf-text-align-left hmf-body-l hmf-body-m-m"
            onMouseEnter={() => searchFromSuggestion(keyword, 'keyword')}
            onFocus={() => searchFromSuggestion(keyword, 'keyword')}
            onClick={(e) => handleSuggestionClick(e, keyword)}
            onKeyDown={(event) => {
              if (event.key === KEY_CODES.RIGHT_ARROW) {
                productsContainerRef.current?.focus();
              }
            }}>
            {reactStringReplace(keyword, searchTerm, (match, i) => (
              <span
                className="dsg-search-suggestion-keyword"
                key={`search-suggestion-keyword-${i}-${keyword}-${match}`}>
                {match}
              </span>
            ))}
          </button>
          <button
            type="button"
            data-testid={`sayt-suggested-keyword-arrow-button-${keyword}`}
            onClick={() => updateSearchTermSAYT(keyword)}
            onKeyDown={(e) => handleADA(e, 'button', updateSearchTermSAYT(keyword))}
            aria-label="arrow button"
            className="dsg-search-suggestion-arrow-button">
            <HomefieldIconArrowBackspace height="15px" width="15px" />
          </button>
        </div>
      ))}
    </>
  );
};

export default memo(
  SuggestionKeywordsResults,
  (prev, next) => prev.suggestionResults === next.suggestionResults,
);
